// Autogenerated file
import en from './en';
import no from './no';

export default {
  'en-GB': en,
  'nb-NO': no,
};
